import React from 'react'
import './Vishvakalyan.css'

const Vishvakalyan = () => {
    return (
        <>
            <section className='Vishvakalyan_section'>
                <div className='container'>
                    <div className='banner_div'>
                        <img className='prathanaimg' src={process.env.PUBLIC_URL + '/assets/images/gurudev/prarthana.png'} alt="prathanaimg" />
                    </div>
                </div>
            </section>
        </>
    )
}

export default Vishvakalyan